module.exports = __webpack_public_path__ + "static/img/1.cdf929f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/6/1.png
// module id = KXr6
// module chunks = 0